import { Component, OnInit } from '@angular/core';
import { SysadminService } from '../../services/sysadmin/sysadmin.service';
import { ReturnObject } from '../../models/returnObject';
import { jobLog } from '../../models/joblog';
import { StatusMessagesService } from '../../services/statusmessage.service';
import { InternalMsgService } from '../../services/internal.msg.service';

@Component({
    selector: 'sysadmin-batch-check',
    templateUrl: './sysadmin-batch-check.component.html',
    styleUrls: ['./sysadmin-batch-check.component.css']
})
export class SysadminBatchCheckComponent implements OnInit {
    message: string = '';
    isErrorLastNight: boolean = false;
    batchResults: jobLog[] = [];
    spinnerMessage: string = 'Please wait, data is fetched';
    datesList: string[] = [];

    constructor(private sysadminService: SysadminService,
        private msgService: InternalMsgService,
        private statusMessagesService: StatusMessagesService) {
        
        this.getBatchErrors();
    }

    ngOnInit() {
    }

    setDateList(): string[] {
        this.datesList.push(this.batchResults[0].logDate) 
        for (let i = 1; i < this.batchResults.length; i++) {
            if ( this.batchResults[i].logDate !== this.datesList[this.datesList.length - 1]) {
                this.datesList.push(this.batchResults[i].logDate);
            }
        }
        return this.datesList;
    }
    getResultForDate(forDate: string): jobLog[] {
        return this.batchResults.filter( x => x.logDate == forDate);
    }
    
    getBatchErrors(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.sysadminService.getErrors()
            .subscribe( { 
                next: (data: ReturnObject<jobLog[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.batchResults = data.value;
                    this.setDateList();
                    this.isErrorLastNight = data.value[0].isSuccess;
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }
}
